'use client';
import React, { useEffect } from 'react';
import { Box } from '@chakra-ui/layout';
import { useToast, Text } from '@chakra-ui/react';
import UpdatePasswordForm from '../components/updatePasswordForm';
import { useNavigate } from 'react-router-dom';
import useTranslation from '../../lib/i18n/useTranslation';
export default function UpdatePasswordPage() {
  const navigate = useNavigate();
  const toast = useToast();
  const { t } = useTranslation();
  return (
    <>
      <Box  p={3} maxW={350} >
      < Text mb={3} >{t('auth.updatePassword')}</Text>
        <UpdatePasswordForm
        hideSave={false}
        onSubmitted={() => {
          navigate('/')
          toast({
            position: 'bottom-right',
            description: t('profile.passwordUpdated'),
            duration: 1000,
            isClosable: true,
            status: 'success'
          });
        }}
        />
      </Box>
    </>
  )
}
